import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

const BloodPressure = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.bloodPressure'} />}
      newButton={
        <DocumentCreationButton
          name="bloodPressure"
          text={'clinicalstudy.newBloodPressure'}
          onClick={startEdit({}, 'bloodPressure')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.bloodPressureSystolic'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.bloodPressureDiastolic'} />
            </Item>
            <Item xs={6} />
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d.date)}
            </Item>
            <Item xs={2}>
              {d.bloodPressureSystolic ? (
                <FormattedMessage id="clinicalstudy.bloodPressureUnit" values={{ n: d.bloodPressureSystolic }} />
              ) : (
                '-'
              )}
            </Item>
            <Item xs={2}>
              {d.bloodPressureDiastolic ? (
                <FormattedMessage id="clinicalstudy.bloodPressureUnit" values={{ n: d.bloodPressureDiastolic }} />
              ) : (
                '-'
              )}
            </Item>
            <Item xs={3} />
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'bloodPressure'>[];
  startEdit: StartEdit;
}

export default BloodPressure;
